import { Head, usePage } from '@inertiajs/react';
import type { ReactNode } from 'react';
import DevtoolsConsoleArt from '@/components/devtools-console-art';

// The persistent shell of every public page of a tour stop: the port of
// `app/(public)/26-{ar,co,mx}/layout.tsx` as one component (PORTING.md G5), nested — as
// it is over there — inside `app/(public)/layout.tsx`'s `<main className="flex-1">`.
//
// Those three route groups span five `pages/<Area>/` directories (Apply, Live, Market,
// PersonCards, Landings), so there is no name prefix to key a default layout on: the
// layout is mounted on every page and decides from the `editionShell` shared prop, which
// only the controllers inside one of those groups set (PORTING.md U9).
//
// It takes only `children` — an Inertia layout function is called twice and the first
// call gets the raw page props, so anything it destructures from an argument blows up.
export function PublicEditionLayout({ children }: { children: ReactNode }) {
  const { editionShell } = usePage().props;

  if (!editionShell) {
    return <>{children}</>;
  }

  return (
    <>
      <Head title={editionShell.name} />
      {/* biome-ignore lint/security/noDangerouslySetInnerHtml: JSON-LD block, same as the Next layout */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: editionShell.jsonLd }}
      />
      <DevtoolsConsoleArt message={editionShell.consoleMessage} />
      <main className="flex-1">
        {editionShell.theme26 ? (
          <div className="theme-ph26 min-h-screen bg-background font-sans text-foreground">
            {children}
          </div>
        ) : (
          children
        )}
      </main>
    </>
  );
}
